export default "__VITE_ASSET__CPm2aV3G__"